module.exports = __webpack_public_path__ + "assets/Heebo-Medium.893d84b76022fce6ee85a5f8d2a8b8d0.woff2";